<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fal fa-cctv" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Stream</h1>
		</div>
	</div>
</div>
<!--<div class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="row">
			<div class="col-md-4" >
				<button id="boton" style="width: 45%;" type="submit" class="btn btn-success"
					(click)="obtenerVideo(1)"><i class="fal fa-cctv"></i>Canal 1</button>
				<button id="boton" style="width: 45%;" type="submit" class="btn btn-success"
					(click)="obtenerVideo(2)"><i class="fal fa-cctv"></i>Canal 2</button>
			</div>
		</div>
	</div>
</div>-->

<mat-card class="mt-2">
	<mat-card-content class="card-content">
		<div class="col col-sm-12 col-md-12 col-lg-12 mt-3">
			<dx-tab-panel #tabPanel class="mt-3" [dataSource]="longtabs" [loop]="false"
				[animationEnabled]="true" [swipeEnabled]="true" (onTitleClick)="obtenerVideo($event)">
				<div *dxTemplate="let canal of 'title'">
					<span>{{canal.titulo}}</span>
				</div>
				<div *dxTemplate="let stream of 'item'" style="margin: 5px;">
					<div *ngIf="verStream1" class="col col-sm-12 col-md-12 col-lg-12 mt-3" style="height: 30rem;">
						<iframe class="video" id="myIframe" [src]="link1 | safeUrl"></iframe>
					</div>
					<div *ngIf="verStream2" class="col col-sm-12 col-md-12 col-lg-12 mt-3" style="height: 30rem;">
						<iframe class="video" id="myIframe" [src]="link2 | safeUrl"></iframe>
					</div>
				</div>
			</dx-tab-panel>
		</div>
	</mat-card-content>
</mat-card>


<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>
